import React from 'react';
import { PageHero } from '../components/PageHero';
import { Product as ProductSection } from '../components/Product';
import { PeriscanOperators } from '../components/PeriscanOperators';
import { Workflow } from '../components/Workflow';
import { FirstReport } from '../components/FirstReport';
import { Integrations } from '../components/Integrations';
import { Competitive } from '../components/Competitive';
import { SectionStage } from '../components/SectionStage';
import { FrontierGatewayTeaser } from '../components/FrontierGatewayTeaser';
export function Product() {
  return <>
      <PageHero eyebrow="Autonomous Security Validation" title="One platform." titleMuted="Continuous proof." description="A self-serve, agentless platform that finds the paths that matter, walks them safely, and proves what's actually exploitable. No sales calls, no enterprise rollout circus — just continuous proof." bg="none" data-id="element-1732" />
      <SectionStage fx="aurora-particles" data-id="element-1733">
        <ProductSection data-id="element-1734" />
      </SectionStage>

      {/* Periscan Operators — rendered without SectionStage so the cinematic
                      blur/opacity transform doesn't dampen the radar sweep behind it. */}
      <PeriscanOperators data-id="element-1735" />

      <SectionStage fx="orbit" data-id="element-1736">
        <FrontierGatewayTeaser data-id="element-1737" />
      </SectionStage>

      <SectionStage fx="circuit" data-id="element-1738">
        <Workflow data-id="element-1739" />
      </SectionStage>
      <SectionStage fx="beams-squares" data-id="element-1740">
        <FirstReport data-id="element-1741" />
      </SectionStage>
      <SectionStage fx="constellation" data-id="element-1742">
        <Integrations data-id="element-1743" />
      </SectionStage>
      <SectionStage fx="lightning" data-id="element-1744">
        <Competitive data-id="element-1745" />
      </SectionStage>
    </>;
}